module.exports = __webpack_public_path__ + "img/4g_03.2ddff27d.png";